import {APIShareTestLink} from "../../features/tests/create/api/createTest";
import {useAuth} from "../../hooks/useAuth";
import Icon from "./Icon";
import CustomButton from "./CustomButton";
import React, {useEffect, useState} from "react";
import Tooltip from "@mui/material/Tooltip";

const CopyTextButton = ({studentId, testId, testExpireDate, disabled = false} : {studentId: number, testId: number, testExpireDate: string, disabled: boolean}) => {
    const {update} = useAuth();
    const [copySuccess, setCopySuccess] = useState('')

    useEffect(() => {
        setTimeout(() => setCopySuccess(''), 2000)
    }, [copySuccess]);

    const handleCopyTestLink = () => {
        APIShareTestLink({
            student_id: studentId,
            test_id: testId,
            test_expire_at: testExpireDate
        })
            .then((response) => {
                if (response.data.success) {
                    const link = response.data.data.value;
                    navigator.clipboard
                        .writeText(link) // Copy it to clipboard
                        .then(() => {
                            // console.log("Link copied to clipboard:", link);
                            setCopySuccess('Link copiat');
                        })
                        .catch(() => {
                            // console.error("Failed to copy link to clipboard:", err);
                            setCopySuccess('Nu s-a putut copia');
                        });

                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                // console.log("APIShareTestLink Error:", err);
                update("error", {show: true, code: "A001"});
            })
    }
    return (
        <Tooltip title={copySuccess ? <span className="blink">{copySuccess}</span> : 'Copiază link'}>
            <span>
                <CustomButton
                    disabled={disabled}
                    width={36}
                    height={36}
                    buttonType="icon"
                    appearance="circle"
                    bgcolor={copySuccess ? "success" : "table"}
                    icon={<Icon icon="far copy" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                    onClick={() => handleCopyTestLink()}
                />
            </span>
        </Tooltip>

    );
}
export default CopyTextButton;